export type PaymentAccount = {
  id: string;
  bank_name: string;
  account_title: string;
  account_number: string;
  iban: string;
  branch_name?: string;
  branch_code?: string;
  swift_code?: string;
  currency: string;
  is_primary: boolean;
};

export const SAAS_PAYMENT_ACCOUNTS: PaymentAccount[] = [
  {
    id: 'hbl-primary',
    bank_name: 'Faysal Bank',
    account_title: 'Netgo Zone',
    account_number: '3583301000005224',
    iban: 'PK73FAYS3583301000005224',
    currency: 'PKR',
    is_primary: true,
  },
];

export const PRIMARY_PAYMENT_ACCOUNT =
  SAAS_PAYMENT_ACCOUNTS.find((a) => a.is_primary) ?? SAAS_PAYMENT_ACCOUNTS[0];
